export default function Projects() {
  const projects = [
    {
      name: "Chennai Ramadan",
      url: "https://chennairamadan.org",
      desc: "Event & community website",
    },
    {
      name: "TGM Nursing Institute",
      url: "https://tgmnursinginstitute.com",
      desc: "Educational institute website",
    },
    {
      name: "Cartly E-commerce",
      url: "https://cartlyecommerce.netlify.app",
      desc: "Full e-commerce platform",
    },
    {
      name: "NJV Travels",
      url: "",
      desc: "Travel booking website",
    },
    {
      name: "Money Management App",
      url: "#",
      desc: "Track expenses and income",
    },
  ];

  return (
    <section id="projects" className="py-12 sm:py-16 px-4 bg-gray-50">
      <div className="max-w-6xl mx-auto">
        
        {/* Heading */}
        <h2 className="text-xl sm:text-2xl md:text-4xl font-bold text-center mb-6">
          Our Projects
        </h2>

        {/* Grid */}
        <div className="grid grid-cols-2  sm:grid-cols-2 md:grid-cols-3 gap-4 sm:gap-6">
          {projects.map((project, i) => (
            <div
              key={i}
              className="bg-white p-4 sm:p-5 rounded-xl shadow-sm hover:shadow-md transition"
            >
              
              {/* Image Placeholder */}
              <div className="h-28 sm:h-32 bg-gray-200 rounded mb-3"></div>

              {/* Title */}
              <h3 className="text-sm sm:text-base md:text-lg font-semibold">
                {project.name}
              </h3>

              {/* Description */}
              <p className="text-xs sm:text-sm text-gray-500 mb-2">
                {project.desc}
              </p>

              {/* Link */}
              <a
                href={project.url}
                target="_blank"
                rel="noreferrer"
                className="text-xs sm:text-sm text-black underline"
              >
                View Project →
              </a>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}